import React from 'react';
import ControlledInput from './controlledInput'
import Editable from './editable'
import TabBar from './tabBar';
import CopyBox from './copyBox';

const tabToType = {'Moto-écoles':'motoecole','Concessionnaires':'concessionnaire'}

class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disable:false
        }
    }

    onDelete() {
        const {receiveContacts} = this.props
        const {nom,prenom,login} = this.props.contact

        if ( window.confirm( 'Supprimer le contact '+ prenom + ' ' + nom + ' ?' )) {
            this.props.api.post(
                {action:'delete_user',
                 login:login
                },
                (res)=>{
                    receiveContacts(res.contacts)
                }
            )
        }
    }

    onReinit() {
        const {receiveContacts} = this.props
        const {login} = this.props.contact
        const me = this

        if ( !this.state.disable ) {
            this.setState({disable:true})
            this.props.api.post(
                {action:'reset_sponsor_contact',
                login:login
                },
                (res)=>{
                    receiveContacts(res.contacts)
                    alert('Voici le nouveau mot de passe assigné à '+login+' : '+res.password+'. Il lui a été envoyé par email.')
                    me.setState({disable:false})
                }
            )
        }
    }

    onChangeParam(param,value) {
        const {receiveContacts,contact} = this.props
        this.props.api.post(
            {action:'update_user',
            login:contact.login,
            param:param,
            value:value
            },
            (res)=>{
                receiveContacts(res.contacts)
            }
        )
    }

    render() {
        const {dg,login,nom,prenom,email,telephone,id} = this.props.contact
        const {type} = this.props.sponsor
        return <tr className={this.state.disable?'disable':''}>
        <td className="dg_td">
            <span onClick={this.onChangeParam.bind(this,'dg',!dg)}>{dg ? '✓ DG' : <span className="stroke">DG</span>}</span>
        </td>
        <td>{login}</td>
        <td><Editable value={nom} onSubmit={this.onChangeParam.bind(this,'nom')}/></td>
        <td><Editable value={prenom} onSubmit={this.onChangeParam.bind(this,'prenom')}/></td>
        <td><Editable value={email} onSubmit={this.onChangeParam.bind(this,'email')}/></td>
        <td><Editable value={telephone} onSubmit={this.onChangeParam.bind(this,'telephone')}/></td>
        <td><CopyBox text={this.props.api.affiliateUrl(login)} displayText="Lien affilié"/></td>
        <td>
            <a href={this.props.api.qrUrl(login,type)} target="_blank">
                Affichette
            </a>
        </td>
        <td className="dg_td">
            <button onClick={this.onDelete.bind(this)}>Supprimer</button>
            <br/>
            <button onClick={this.onReinit.bind(this)}>Réinitialiser</button>
        </td>
    </tr>
    }
}

class Sponsor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            login:'',
            nom:'',
            prenom:'',
            email:'',
            telephone:'',
            unfold:false,
            contacts:[],
            disable:false
        }
    }

    onDelete() {
        const {receiveSponsors,sponsor} = this.props
        const {_id,nom} = sponsor

        if ( window.confirm( 'Supprimer l\'affilié '+ nom + ' ?' )) {
            const me = this
            this.props.api.post(
                {action:'delete_sponsor',
                 sponsor_id:_id.$oid
                },
                (res)=>{
                    receiveSponsors(res.sponsors)
                }
            )
        }
    }


    onAdd() {
        if ( this.state.disable ) return
        const receiveContacts = this.receiveContacts.bind(this)
        this.setState({disable:true})
        this.props.api.post({
            action:'add_sponsor_contact',
            sponsor:this.props.sponsor._id.$oid,
            login:this.state.login,
            nom:this.state.nom,
            prenom:this.state.prenom,
            email:this.state.email,
            telephone:this.state.telephone
        },
        (res)=>{
            receiveContacts(res.contacts)
            this.setState({'login':'','nom':'','prenom':'','email':'','telephone':''})
            if ( res.alert ) {
                alert(res.alert)
            } else {
                alert('Voici le nouveau mot de passe assigné à '+this.state.login+' : '+res.password+'. Il lui a été envoyé par email.')
            }
            this.setState({disable:false})
        },
        (error)=>{
            alert(error)
            this.setState({disable:false})
        }
        )
    }

    onChangeParam(param,value) {
        const {receiveSponsors,sponsor} = this.props
        const {_id} = sponsor
        this.props.api.post(
            {action:'set_sponsor',
            sponsor_id:_id.$oid,
            param:param,
            value:value
            },
            (res)=>{
                receiveSponsors(res.sponsors)
            }
        )
    }

    renderContacts() {
        return <tr>
            <td className="head_td"></td>
            <td colSpan="5">
                <table className="subtable_grey">
                <thead>
                <tr>
                    <th></th>
                    <th>Login</th>
                    <th>Nom</th>
                    <th>Prénom</th>
                    <th>email</th>
                    <th>téléphone</th>
                </tr>
                <tr className={this.state.disable?'disable':''}>
                    <th></th>
                    <th>
                        <ControlledInput type='text' property='login' container={this} onSubmit={this.onAdd.bind(this)}/>
                    </th>
                    <th>
                        <ControlledInput type='text' property='nom' container={this} onSubmit={this.onAdd.bind(this)}/>
                    </th>
                    <th>
                        <ControlledInput type='text' property='prenom' container={this} onSubmit={this.onAdd.bind(this)}/>
                    </th>
                    <th>
                        <ControlledInput type='text' property='email' container={this} onSubmit={this.onAdd.bind(this)}/>
                    </th>
                    <th>
                        <ControlledInput type='text' property='telephone' container={this} onSubmit={this.onAdd.bind(this)}/>
                    </th>
                    <th>
                        <button onClick={this.onAdd.bind(this)}>Créer</button>
                    </th>
                </tr>
                </thead>
                <tbody>
                {this.state.contacts.map( contact => 
                    <Contact 
                        sponsor={this.props.sponsor}
                        contact={contact}
                        receiveContacts={ this.receiveContacts.bind(this) }
                        api={this.props.api}
                        key={contact.login}
                    />
                )}
                </tbody>
                </table>
            </td>
        </tr>
    }

    receiveContacts(contacts) {
        this.setState({contacts:contacts})
    }

    switchFold() {
        const {_id} = this.props.sponsor
        const receiveContacts = this.receiveContacts.bind(this)
        if ( this.state.unfold ) {
            this.setState({unfold:false})
        } else {
            this.setState({unfold:true})
            this.props.api.post(
                {action:'get_contacts',
                sponsor:_id.$oid
                },
                (res)=>{
                    receiveContacts(res.contacts)
                }
            )
        }
    }

    render() {
        const {nom,adresse,cp,ville,_id} = this.props.sponsor
        return <><tr >
            <td onClick={ this.switchFold.bind(this) } className="head_td">{this.state.unfold ? '▼' : '▶'}</td>
            <td>
            &nbsp;
            &nbsp;
            <Editable value={nom} onSubmit={this.onChangeParam.bind(this,'nom')}/></td>
            <td><Editable value={adresse} onSubmit={this.onChangeParam.bind(this,'adresse')}/></td>
            <td><Editable value={cp} onSubmit={this.onChangeParam.bind(this,'cp')}/></td>
            <td><Editable value={ville} onSubmit={this.onChangeParam.bind(this,'ville')}/></td>
            {(this.state.contacts.length==0)?
                <td className="head_td"><img src='img/delete-bin-line.png' className='button' onClick={this.onDelete.bind(this)}/></td>
                :<></>}
        </tr>
        {this.state.unfold ? this.renderContacts() : <></>}
        </>
    }
}

class Sponsors extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sponsors:[],
            type:'Moto-écoles',
            nom:'',
            adresse:'',
            cp:'',
            ville:''
        }
    }

    componentDidMount() {
        this.props.api.post(
            {action:'list_sponsors'},
            (res)=>{
                this.setState({sponsors:res.sponsors})
            }
        )
    }

    renderSponsor(sponsor) {
        return <Sponsor 
            api={this.props.api} 
            sponsor={sponsor} 
            receiveSponsors={this.receiveSponsors.bind(this)}
            key={sponsor._id.$oid}
        />
    }

    receiveSponsors(sponsors) {
        this.setState({sponsors:sponsors}) 
    }

    onAdd() {
        this.props.api.post({
            action:'add_sponsor',
            type:tabToType[this.state.type],
            nom:this.state.nom,
            adresse:this.state.adresse,
            cp:this.state.cp,
            ville:this.state.ville
        },
        (res)=>{
            this.setState({sponsors:res.sponsors,'nom':'','adresse':'','cp':'','ville':''})
        }
        )
    }

    render() {
        return <div>
            <TabBar 
            tabs={ ['Moto-écoles','Concessionnaires'] }
            tab={this.state.type} 
            setTab={ (type) => { this.setState({type:type}) } } 
            api={this.props.api} 
          >
          </TabBar>
          <div className="content">
            <table className="table_grey">
            <thead>
                <tr>
                    <th></th>
                    <th>Nom</th>
                    <th>Adresse</th>
                    <th>Code postal</th>
                    <th>Ville</th>
                    <th></th>
                </tr>
                <tr>
                    <th></th>
                    <th>
                        <ControlledInput type='text' property='nom' container={this} onSubmit={this.onAdd.bind(this)}/>
                    </th>
                    <th>
                        <ControlledInput type='text' property='adresse' container={this} onSubmit={this.onAdd.bind(this)}/>
                    </th>
                    <th>
                        <ControlledInput type='text' property='cp' container={this} onSubmit={this.onAdd.bind(this)}/>
                    </th>
                    <th>
                        <ControlledInput type='text' property='ville' container={this} onSubmit={this.onAdd.bind(this)}/>
                    </th>
                    <th>
                        <button onClick={this.onAdd.bind(this)}>Créer</button>
                    </th>
                </tr>
            </thead>
            <tbody>
                {this.state.sponsors.filter( sponsor=>sponsor.type == tabToType[this.state.type] )
                                    .map( this.renderSponsor.bind(this) )}
            </tbody>
        </table></div></div>
    }
}

export default Sponsors;
